import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'ng2-select';
import { SharedUiModule } from '../../shared/ui';
import { SessionModule } from '../session';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE, OwlDateTimeIntl } from 'ng-pick-datetime';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { YesNoPipe } from './yes-no.pipe';
import { TzDatePipe } from './tzdate.pipe';
import { SelectComponent } from './select.component';
import { OptionComponent } from './option.component';
import { PercentComponent } from './percent.component';

import { NotifierService, AlertComponent, AlertsComponent } from './alert';

import { DialogService, DialogsComponent, ConfirmDialogComponent } from './dialog';
import { FileSizePipe } from './filesize.pipe';
import { EmptyPipe } from './empty.pipe';
import { OwlFrIntl } from './owl-locale';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    SelectModule,
    SharedUiModule,
    SessionModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    NoopAnimationsModule,
  ],
  declarations: [
    YesNoPipe,
    TzDatePipe,
    EmptyPipe,
    FileSizePipe,
    SelectComponent,
    OptionComponent,
    PercentComponent,
    
    AlertComponent,
    AlertsComponent,
    
    DialogsComponent,
    ConfirmDialogComponent
  ],
  exports: [
    YesNoPipe,
    TzDatePipe,
    EmptyPipe,
    FileSizePipe,
    SelectComponent,
    OptionComponent,
    PercentComponent,

    AlertsComponent,

    DialogsComponent,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
  ],
  providers: [
    NotifierService,
    DialogService,
    // use french locale
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'fr'},
    {provide: OwlDateTimeIntl, useClass: OwlFrIntl},
  ]
})
export class UiModule { }
